import { gql } from "@apollo/client";

const STEAMBOT_STATUS_FIELDS = `
  eligible
  enrolled
  capacityAvailable
  bot {
    steamId64
    profileUrl
  }
`;

export const STEAMBOT_STATUS = gql`
  query SteambotStatus {
    steambotStatus {
      ${STEAMBOT_STATUS_FIELDS}
    }
  }
`;

export const STEAMBOT_REQUEST_ASSIGNMENT = gql`
  mutation SteambotRequestAssignment {
    steambotRequestAssignment {
      ${STEAMBOT_STATUS_FIELDS}
    }
  }
`;
